module.exports = __webpack_public_path__ + "static/media/chevron-circle-down.28ecaca7.svg";